import {createContext} from "react";
export const CategoriesContext = createContext([])
export const BrandsContext = createContext([])
export const ProductTypesContext = createContext([])
export const UserContext = createContext([])
export const IsDriverApprovedContext = createContext([])